<template>
  <div class="fix-width-container full-lib-search">
    <search-component 
      :history="true"
      @wordSearch="search"
      @dimensionChange="dimensionChange"
    />
    <p 
      v-show="showTip"
      class="search-tip"
    >注：该条件下的关键词检索，仅在“数据列表”页做结果展现。</p>
    <el-tabs 
      class="sub-tab" 
      v-model="activeTab" 
      type="card"
    >
      <el-tab-pane
        label="专题列表"
        name="first"
      >
        <theme-list ref="themeList" />
      </el-tab-pane>
      <el-tab-pane
        label="数据列表"
        name="second"
      >
        <data-list ref="dataList" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import searchComponent from "@/components/searchComponent"

import themeList from '@/modules/fullLibSearch-out/themeList'
import dataList from '@/modules/fullLibSearch-out/dataList'

export default {
  components: {
    searchComponent,
    themeList,
    dataList
  },
  data () {
    return {
      activeTab: 'second',
      showTip: false
    }
  },
  mounted () {
    // 如果是搜索标签等过来的 且有搜索词，提示并默认展示数据页面
    if (this.$route.query.content) {
      this.dimensionChange(this.$route.query.type)
    }
  },
  methods: {
    dimensionChange (type) {
      if (['tags', 'sourceNames'].indexOf(type) !== -1) {
        this.showTip = true
        this.activeTab = 'second'
        return true
      } 
      this.showTip = false
      return false
    },
    // 全库检索时，下面两个列表都执行搜索方法
    search (data) {
      this.$refs.themeList.wordSearch(data)
      this.$refs.dataList.wordSearch(data)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/fullLibSearch-out/fullLibSearch.vue